import React, { FC } from 'react';

import { CartButton } from 'src/shoppe/elements/CartButton';

import styles from './index.module.sass';

const Cart: FC = () => <CartButton className={styles.cart} />;

export default Cart;
